module.exports = __webpack_public_path__ + "static/media/IGeneral2.d04ced64.svg";